/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "resources": {
                "nested": {
                  "ProductTaxon": {
                    "fields": {
                      "key": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "name": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "description": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "translationKey": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "parentKey": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "childrenCount": {
                        "type": "int32",
                        "id": 6,
                        "rule": "optional"
                      },
                      "productKeys": {
                        "type": "string",
                        "id": 7,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.resources?.nested?.ProductTaxon) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE ProductTaxon @ squareup/solidshop/v2/resources/taxon.proto at 8:1
 */
export const ProductTaxon = $root.lookupType('squareup.solidshop.v2.resources.ProductTaxon');
fixType(ProductTaxon);
Builder.createAndAttachToType(ProductTaxon);
